import { render, staticRenderFns } from "./MisCertificados.vue?vue&type=template&id=24ef7e36&scoped=true"
import script from "./MisCertificados.vue?vue&type=script&lang=js"
export * from "./MisCertificados.vue?vue&type=script&lang=js"
import style0 from "./MisCertificados.vue?vue&type=style&index=0&id=24ef7e36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ef7e36",
  null
  
)

export default component.exports